module.exports = __webpack_public_path__ + "static/img/头盔.f4823cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/首页/新建文件夹/头盔.png
// module id = B/J8
// module chunks = 192